/**
 * Provides a helper function to get the labels for the min/max range fields in the control panel.
 * 
 * @packageDocumentation
 * @module AxisRangeFieldLabels
 * @public
 */

// -- type definitions --

/**
 * Labels for the min/max range fields in the control panel.
 */
export interface AxisRangeFieldLabels {
  helperText: string;
  minLabel: string;
  maxLabel: string;
}

// -- helper function --

/**
 * Get the labels for the min/max range fields in the control panel.
 */
export function getAxisRangeFieldLabels(
  zoomEnabled: boolean
): AxisRangeFieldLabels {
  if (zoomEnabled) {
    return {
      helperText:
        'Plage affichée au chargement et après double-clic. Le zoom libre est possible.',
      minLabel: 'Min par défaut',
      maxLabel: 'Max par défaut',
    };
  }

  return {
    helperText: 'Plage imposée sur le graphique. Aucun zoom ni déplacement.',
    minLabel: 'Min fixe',
    maxLabel: 'Max fixe',
  };
}
